import { createReducer, on } from '@ngrx/store';
import { ErrorReceived, ClearError } from './error.actions';
import { initialState } from './error.state';

export const reducer = createReducer(
  initialState,

  on(ErrorReceived, (state, { error }) => ({
    ...state,
    name: error.name,
    errorMessage: error.message,
    stack: error.stack
  })),

  on(ClearError, () => ({
    ...initialState
  }))
);
